// extracted by mini-css-extract-plugin
module.exports = {"dialogPanel":"_3Ck20l","buttons":"_2qm4Rl","buttonYes":"_1zdpWV","buttonNo":"eH4Zi2","title":"_38HHxO","iconContainer":"_379NHK"};